// The one basemap every map on the site draws: MapLibre GL over OpenFreeMap's
// vector tiles. No API key, no quota, no cookies and no bill — which is why a
// creator's page map and a single place's map both sit here rather than on
// Google's or Mapbox's meter. `positron` is the pale grey style, so whatever
// is pinned on it is the only saturated thing on screen.
export const STYLE = "https://tiles.openfreemap.org/styles/positron"

// Native ES modules from public/, NOT bundled through esbuild — the build
// script marks /maplibre/* external so this import survives to the browser.
//
// MapLibre 6 ships three chunks: an entry, a shared chunk, and a worker it
// locates with `new URL("./maplibre-gl-worker.mjs", import.meta.url)`. Bundling
// the entry folds the shared chunk into it and silently drops the worker, so
// that URL 404s — and the failure is invisible: no tile is ever requested, no
// error is fired, and the map paints its controls over a blank grey box.
// Served side by side under /maplibre/, the relative URL resolves on its own.
//
// Dynamic, so the engine is fetched only by a page that actually has a map,
// not by every page that loads application.js.
const ENGINE = "/maplibre/maplibre-gl.mjs"

export function loadMapLibre() { return import(ENGINE) }
